import { HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CaptchaType } from "@gloria-public/register/domain/interfaces/captcha.interface";
import { ApiService } from "@shared/services/api.service";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class CaptchaService {
  constructor(private api: ApiService) {}

  /**
   * Generates a captcha image for a given type
   * @param type Captcha type to generate
   * @return captcha blob response
   */
  public generateCaptcha(type: CaptchaType): Observable<HttpResponse<Blob>> {
    return this.api.getBlobAsFullResponse("generate-captcha", { type }, false) as Observable<HttpResponse<Blob>>;
  }

  /**
   * Verifies a captcha answer
   * @param captchaId Captcha identifier
   * @param userAnswer User provided answer
   * @return verification result as text response
   */
  public verifyCaptcha(captchaId: string | null, userAnswer: string): Observable<string> {
    return this.api.post("answer-captcha/" + captchaId, userAnswer, undefined, false, undefined, "text") as Observable<string>;
  }
}
